import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { getUserProfileDetails, updateUserProfileDetails } from "../../../core/api/authAPI";
import useAuthStore from "../../../core/store/authStore";
import { QUERY_KEYS, UI_MESSAGE, QUERY_CONFIG } from "../../../core/config/Constant";

/**
 * Get User Profile Details
 */
export const useUser = () => {
  const queryClient = useQueryClient();
  const { setUserProfile, isLoggedIn } = useAuthStore();

  // 1. Fetcher with logic to sync to Zustand
  const query = useQuery({
    queryKey: [QUERY_KEYS.USER_PROFILE],
    queryFn: async () => {
      const response = await getUserProfileDetails();
      if (response?.success === true) setUserProfile(response?.data);
      return response?.data;
    },
    enabled: isLoggedIn,
    staleTime: QUERY_CONFIG.STALE_TIME,
    cacheTime: QUERY_CONFIG.CACHE_TIME,
  });

  // Update User Profile Details
  const mutation = useMutation({
    mutationFn: (payload) => updateUserProfileDetails(payload),
    onSuccess: (data, variables) => {
      const isImage = variables instanceof FormData;
      toast.success(isImage ? UI_MESSAGE.IMAGE_UPLOAD_SUCCESS : UI_MESSAGE.PROFILE_UPDATE_SUCCESS);

      // Invalidate cache to trigger background refetch
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.USER_PROFILE] });

      // Sync result to Zustand
      if (data) setUserProfile(data);
    },
    onError: (error, variables) => {
      console.error("Profile update error:", error);
      const isImage = variables instanceof FormData;
      toast.error(isImage ? UI_MESSAGE.IMAGE_UPLOAD_FAILED : UI_MESSAGE.PROFILE_UPDATE_FAILED);
    },
  });

  return {
    userProfile: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    profileQuery: query,
    userProfileMutation: mutation,
  };
};

export default useUser;
